import { rateTypeOptions } from '../lib/Constants'
import {
  elementTypes,
  getFirstKeyFromObject,
  requiredAuthorizationOptions
} from './formBuilder'

export const numericOptions = [
  'numeric_only',
  'dollar_value',
  'percentage_value'
]

export const getNested = (obj, ...args) => {
  return args.reduce((obj, level) => obj && obj[level], obj)
}

const countDots = inputString => {
  const dots = inputString.match(/\./g)
  return dots ? dots.length : 0
}

const replaceDots = inputString => {
  let firstDotProcessed = false

  return inputString.replace(/\./g, function (match) {
    if (!firstDotProcessed) {
      firstDotProcessed = true
      return match // Keep the first dot
    } else {
      return '' // Replace subsequent dots with an empty string
    }
  })
}

export const inputTypeValueTransformer = (inputType, value) => {
  switch (inputType) {
    case 'alpha_numeric':
      return value.replace(/[^a-zA-Z0-9\s]/g, '')
    case 'alpha_only':
      return value.replace(/[^a-zA-Z\s]+/gi, '')
    case 'numeric_only':
    case 'dollar_value':
    case 'percentage_value': {
      if (countDots(value) > 1) {
        const modValue = value?.replace(/[^0-9.]+/gi, '')
        return replaceDots(modValue)
      } else {
        return value?.replace(/[^0-9.]+/gi, '')
      }
    }
    default:
      return value
  }
}

export const checkFullFilledMandatoryQuestion = (questionData, answer) => {
  const questionType = questionData.type
  switch (questionType) {
    case elementTypes.MULTI_BUTTON_SELECTION:
    case elementTypes.DROPDOWN_SELECTION: {
      let selected = 0
      answer?.forEach(option => {
        if (option === true || option === false) {
          selected++
        }
      })
      if (selected === 0) {
        return false
      }
      return true
    }
    case elementTypes.CHECKLIST_ITEM: {
      if (answer === null || answer === undefined) return false
      return true
    }
    case elementTypes.AUTHORIZATION_FIELD: {
      let completeAuth = false
      if (
        answer?.url &&
        questionData.required !== requiredAuthorizationOptions.DISABLE
      ) {
        completeAuth = true
      }
      if (
        questionData.required ===
        requiredAuthorizationOptions.SIGNATURE_AND_NAME_REQUIRED
      ) {
        completeAuth = answer?.[0]?.title?.length > 0
      }
      return completeAuth
    }
    case elementTypes.SIGNATURE: {
      let fullfilled = true
      if (!answer?.url) fullfilled = false
      if (
        questionData.attributes === 'entered_name_required' &&
        !answer?.title
      ) {
        fullfilled = false
      }
      return fullfilled
    }
    case elementTypes.PHOTOS: {
      return true
    }
    case elementTypes.ATTACHMENTS: {
      return true
    }
    case elementTypes.MATERIAL_PARTS: {
      if (answer?.length === 0) {
        return false
      }

      let fullfilledItems = true
      if (answer?.length > 0) {
        for (const item of answer) {
          if (!item.quantity || !item.name) {
            fullfilledItems = false
            break
          }
        }
      }
      return fullfilledItems
    }
    case elementTypes.LINE_ITEMS: {
      if (answer?.length === 0 || answer === null || answer === undefined) {
        return false
      }

      let fullfilledItems = 0
      if (answer?.length > 0) {
        for (const item of answer) {
          if (
            questionData?.line_item &&
            !!item?.line_item &&
            questionData?.rate !== rateTypeOptions.DISABLE &&
            !!item?.rate
          ) {
            fullfilledItems++
          }
        }
      }
      return fullfilledItems > 0
    }
    default:
      if (!answer || answer === '') {
        return false
      }
      return true
  }
}

export const pendingTasksCounter = (configurations, dataObject) => {
  let totalMandatoryTasks = 0
  let unresolvedTasks = 0
  if (configurations && dataObject) {
    for (const page of configurations) {
      for (const section of page.page_questions) {
        const sectionKey = getFirstKeyFromObject(section)
        const sectionQuestions = section[sectionKey].questions
        for (const question of sectionQuestions) {
          const questionKey = getFirstKeyFromObject(question)
          const questionObj = question[questionKey]
          if (
            questionObj.required === true ||
            (questionObj.type === elementTypes.AUTHORIZATION_FIELD &&
              questionObj.required !== 'disable')
          ) {
            totalMandatoryTasks++
            if (questionObj.type === elementTypes.PHOTOS) {
              const photos = questionObj.photos
              const answer = getNested(dataObject, sectionKey, questionKey)
              let fullfilled = true
              photos.forEach(photo => {
                if (photo.required === true) {
                  if (answer) {
                    const photoTitle = photo.title
                    const foundPhoto = answer?.find(
                      photo => photo.title === photoTitle
                    )
                    if (!foundPhoto) {
                      fullfilled = false
                    }
                  } else {
                    fullfilled = false
                  }
                }
              })
              if (!fullfilled) {
                unresolvedTasks++
              }
            }
            if (questionObj.type === elementTypes.ATTACHMENTS) {
              const attachments = questionObj.attachments
              const answer = getNested(dataObject, sectionKey, questionKey)
              let fullfilled = true
              attachments.forEach(attachment => {
                if (attachment.required === true) {
                  if (answer) {
                    const attachmentTitle = attachment.title
                    const foundAttachment = answer?.find(
                      attachment => attachment.title === attachmentTitle
                    )
                    if (!foundAttachment) {
                      fullfilled = false
                    }
                  } else {
                    fullfilled = false
                  }
                }
              })
              if (!fullfilled) {
                unresolvedTasks++
              }
            }
            if (
              questionObj.type !== elementTypes.PHOTOS ||
              questionObj.type !== elementTypes.ATTACHMENTS
            ) {
              const answer = getNested(dataObject, sectionKey, questionKey)
              const fullfilledMandatory = checkFullFilledMandatoryQuestion(
                questionObj,
                answer
              )
              if (!fullfilledMandatory) {
                unresolvedTasks++
              }
            }
          }
        }
      }
    }
    return [unresolvedTasks, totalMandatoryTasks]
  }
}

export const checkBoxModes = {
  CHECK_BOX: 'check_box',
  ON_OFF: 'on_off',
  YES_NO: 'yes_no',
  TOGGLE: 'toggle'
}
